"use strict";
/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connector = exports.onLanguageChanged = exports.changeLanguage = exports.isInit = exports.onMissingKey = exports.i18nUtils = exports.onInit = exports.init = exports.i18n = exports.bundled = void 0;
// tslint:disable
var loom_i18n_1 = require("loom-i18n");
var en_1 = require("loom-i18n/dist/locale-data/en");
var ar_1 = require("loom-i18n/dist/locale-data/ar");
var cs_1 = require("loom-i18n/dist/locale-data/cs");
var da_1 = require("loom-i18n/dist/locale-data/da");
var de_1 = require("loom-i18n/dist/locale-data/de");
var el_1 = require("loom-i18n/dist/locale-data/el");
var es_1 = require("loom-i18n/dist/locale-data/es");
var fi_1 = require("loom-i18n/dist/locale-data/fi");
var fr_1 = require("loom-i18n/dist/locale-data/fr");
var hr_1 = require("loom-i18n/dist/locale-data/hr");
var hu_1 = require("loom-i18n/dist/locale-data/hu");
var it_1 = require("loom-i18n/dist/locale-data/it");
var ja_1 = require("loom-i18n/dist/locale-data/ja");
var ko_1 = require("loom-i18n/dist/locale-data/ko");
var nl_1 = require("loom-i18n/dist/locale-data/nl");
var no_1 = require("loom-i18n/dist/locale-data/no");
var pl_1 = require("loom-i18n/dist/locale-data/pl");
var pt_1 = require("loom-i18n/dist/locale-data/pt");
var ro_1 = require("loom-i18n/dist/locale-data/ro");
var ru_1 = require("loom-i18n/dist/locale-data/ru");
var sk_1 = require("loom-i18n/dist/locale-data/sk");
var sl_1 = require("loom-i18n/dist/locale-data/sl");
var sr_1 = require("loom-i18n/dist/locale-data/sr");
var sv_1 = require("loom-i18n/dist/locale-data/sv");
var th_1 = require("loom-i18n/dist/locale-data/th");
var tr_1 = require("loom-i18n/dist/locale-data/tr");
var zh_1 = require("loom-i18n/dist/locale-data/zh");
exports.bundled = {};
exports.bundled["en"] = {
    Connector: {
        Errors: {
            defaultError: "An unexpected error occurred.",
            offlineError: "NetworkError when attempting to fetch resource.",
            parseJSONError: "Unable to parse the error JSON body."
        }
    }
};
exports.bundled["ar-XB"] = {
    Connector: {
        Errors: {
            defaultError: "[‏‮An unexpected error occurred.‬‏]",
            offlineError: "[‏‮NetworkError when attempting to fetch resource.‬‏]",
            parseJSONError: "[‏‮Unable to parse the error JSON body.‬‏]"
        }
    }
};
exports.bundled["cs"] = {
    Connector: {
        Errors: {
            defaultError: "Vyskytla se neočekávaná chyba.",
            offlineError: "Při pokusu o načtení zdroje došlo k chybě sítě NetworkError",
            parseJSONError: "Nelze analyzovat tělo chyby JSON."
        }
    }
};
exports.bundled["da"] = {
    Connector: {
        Errors: {
            defaultError: "Der opstod en uventet fejl.",
            offlineError: "NetworkError, når hentning af ressource forsøges.",
            parseJSONError: "Kan ikke analysere JSON-fejlbrødteksten."
        }
    }
};
exports.bundled["de"] = {
    Connector: {
        Errors: {
            defaultError: "Ein unerwarteter Fehler ist aufgetreten.",
            offlineError: "Netzwerkfehler beim Versuch zum Abrufen der Ressource.",
            parseJSONError: "JSON-Body des Fehlers kann nicht geparst werden."
        }
    }
};
exports.bundled["el"] = {
    Connector: {
        Errors: {
            defaultError: "Παρουσιάστηκε μη αναμενόμενο σφάλμα.",
            offlineError: "Παρουσιάστηκε σφάλμα δικτύου κατά την προσπάθεια ανάκτησης πόρου.",
            parseJSONError: "Δεν είναι δυνατή η ανάλυση του κυρίως σώματος JSON σφαλμάτων."
        }
    }
};
exports.bundled["en-XA"] = {
    Connector: {
        Errors: {
            defaultError: "[PX][An unexpected error occurred. éëž]",
            offlineError: "[PX][NetworkError when attempting to fetch resource. éëžéëžéëž]",
            parseJSONError: "[PX][Unable to parse the error JSON body. éëžéë]"
        }
    }
};
exports.bundled["en-XC"] = {
    Connector: {
        Errors: {
            defaultError: "[[oci_console_oui/packages/oui-savant/locales/en.json:::Connector:Errors:defaultError:::An unexpected error occurred.]]",
            offlineError: "[[oci_console_oui/packages/oui-savant/locales/en.json:::Connector:Errors:offlineError:::NetworkError when attempting to fetch resource.]]",
            parseJSONError: "[[oci_console_oui/packages/oui-savant/locales/en.json:::Connector:Errors:parseJSONError:::Unable to parse the error JSON body.]]"
        }
    }
};
exports.bundled["en"] = {
    Connector: {
        Errors: {
            defaultError: "An unexpected error occurred.",
            offlineError: "NetworkError when attempting to fetch resource.",
            parseJSONError: "Unable to parse the error JSON body."
        }
    }
};
exports.bundled["es"] = {
    Connector: {
        Errors: {
            defaultError: "Se ha producido un error inesperado.",
            offlineError: "Se ha producido NetworkError al tratar de recuperar el recurso.",
            parseJSONError: "No se ha podido analizar el cuerpo JSON del error."
        }
    }
};
exports.bundled["fi"] = {
    Connector: {
        Errors: {
            defaultError: "Odottamaton virhe",
            offlineError: "NetworkError-virhe yritettäessä noutaa reusrssia.",
            parseJSONError: "Virheen JSON-runkoa ei voi jäsentää."
        }
    }
};
exports.bundled["fr-CA"] = {
    Connector: {
        Errors: {
            defaultError: "Erreur inattendue.",
            offlineError: "Erreur réseau lors d'une tentative d'extraction de ressource.",
            parseJSONError: "Impossible d'analyser le corps JSON de l'erreur."
        }
    }
};
exports.bundled["fr"] = {
    Connector: {
        Errors: {
            defaultError: "Une erreur inattendue est survenue.",
            offlineError: "Erreur de réseau lors de la tentative d'extraction de la ressource.",
            parseJSONError: "Impossible d'analyser le corps JSON de l'erreur."
        }
    }
};
exports.bundled["hr"] = {
    Connector: {
        Errors: {
            defaultError: "Došlo je do neočekivane pogreške.",
            offlineError: "Pri pokušaju dohvaćanja resursa došlo je do mrežne pogreške.",
            parseJSONError: "Glavni dio JSON datoteke pogreške nije se mogao analizirati."
        }
    }
};
exports.bundled["hu"] = {
    Connector: {
        Errors: {
            defaultError: "Váratlan hiba történt.",
            offlineError: "NetworkError az erőforrás beolvasásának megkísérlésekor.",
            parseJSONError: "Nem elemezhető a hiba JSON-törzse."
        }
    }
};
exports.bundled["it"] = {
    Connector: {
        Errors: {
            defaultError: "Si è verificato un errore imprevisto.",
            offlineError: "NetworkError durante il tentativo di recupero della risorsa.",
            parseJSONError: "Impossibile analizzare il corpo JSON dell'errore."
        }
    }
};
exports.bundled["ja"] = {
    Connector: {
        Errors: {
            defaultError: "予期しないエラーが発生しました。",
            offlineError: "リソースをフェッチしようとしたときにNetworkErrorが発生しました。",
            parseJSONError: "エラーJSON本文を解析できません。"
        }
    }
};
exports.bundled["ko"] = {
    Connector: {
        Errors: {
            defaultError: "예상치 않은 오류가 발생했습니다.",
            offlineError: "리소스를 인출하려고 시도하는 중 NetworkError가 발생했습니다.",
            parseJSONError: "오류 JSON 본문을 구문분석할 수 없습니다."
        }
    }
};
exports.bundled["nl"] = {
    Connector: {
        Errors: {
            defaultError: "Er is een onverwachte fout opgetreden.",
            offlineError: "Netwerkfout bij het ophalen van de resource",
            parseJSONError: "Incorrecte JSON-hoofdtekst kan niet worden ontleed."
        }
    }
};
exports.bundled["no"] = {
    Connector: {
        Errors: {
            defaultError: "Det oppstod en uventet feil.",
            offlineError: "Nettverksfeil ved forsøk på å hente ressurs.",
            parseJSONError: "Kan ikke analysere JSON-feilteksten."
        }
    }
};
exports.bundled["pl"] = {
    Connector: {
        Errors: {
            defaultError: "Wystąpił nieoczekiwany błąd.",
            offlineError: "Błąd sieciowy podczas próby pobrania zasobu.",
            parseJSONError: "Nie można wykonać analizy składniowej treści JSON komunikatu o błędzie."
        }
    }
};
exports.bundled["pt-PT"] = {
    Connector: {
        Errors: {
            defaultError: "Ocorreu um erro inesperado.",
            offlineError: "NetworkError ao tentar obter o recurso.",
            parseJSONError: "Incapaz de analisar o corpo de JSON em erro."
        }
    }
};
exports.bundled["pt"] = {
    Connector: {
        Errors: {
            defaultError: "Erro inesperado.",
            offlineError: "Erro de Rede ao tentar extrair o recurso.",
            parseJSONError: "Não é possível fazer parsing do corpo do JSON do erro."
        }
    }
};
exports.bundled["ro"] = {
    Connector: {
        Errors: {
            defaultError: "A survenit o eroare neaşteptată.",
            offlineError: "Eroare reţea la încercarea de preluare a resursei.",
            parseJSONError: "Nu s-a putut interpreta conţinutul erorii JSON."
        }
    }
};
exports.bundled["ru"] = {
    Connector: {
        Errors: {
            defaultError: "Возникла непредвиденная ошибка.",
            offlineError: "Ошибка NetworkError при попытке извлечения ресурса.",
            parseJSONError: "Не удается выполнить синтаксический разбор кода JSON для ошибки."
        }
    }
};
exports.bundled["sk"] = {
    Connector: {
        Errors: {
            defaultError: "Vyskytla sa neočakávaná chyba.",
            offlineError: "Pri pokuse o vyvolanie prostriedku nastala chyba siete.",
            parseJSONError: "Chybné telo JSON nie je možné syntakticky analyzovať."
        }
    }
};
exports.bundled["sl"] = {
    Connector: {
        Errors: {
            defaultError: "Prišlo je do nepričakovane napake.",
            offlineError: "Pri pridobivanju vira je prišlo do NetworkError.",
            parseJSONError: "Ni mogoče razčleniti telesa JSON napake."
        }
    }
};
exports.bundled["sr-Latn"] = {
    Connector: {
        Errors: {
            defaultError: "Došlo je do neočekivane greške.",
            offlineError: "Došlo je do mrežne greške prilikom pokušaja preuzimanja resursa.",
            parseJSONError: "Nije moguće analizirati grešku u telu JSON zapisa."
        }
    }
};
exports.bundled["sr"] = {
    Connector: {
        Errors: {
            defaultError: "Дошло је до неочекиване грешке.",
            offlineError: "Дошло је до мрежне грешке приликом покушаја преузимања ресурса.",
            parseJSONError: "Није могуће анализирати грешку у телу JSON записа."
        }
    }
};
exports.bundled["sv"] = {
    Connector: {
        Errors: {
            defaultError: "Ett oväntat fel har inträffat.",
            offlineError: "Ett nätverksfel inträffade vid försök att hämta resurs.",
            parseJSONError: "Kan inte tolka det felaktiga JSON-innehållet."
        }
    }
};
exports.bundled["th"] = {
    Connector: {
        Errors: {
            defaultError: "เกิดข้อผิดพลาดที่ไม่คาดหมาย",
            offlineError: "เกิดข้อผิดพลาดกับเน็ตเวิร์กขณะพยายามดึงข้อมูลทรัพยากร",
            parseJSONError: "ไม่สามารถพาร์ซเนื้อหา JSON ของข้อผิดพลาด"
        }
    }
};
exports.bundled["tr"] = {
    Connector: {
        Errors: {
            defaultError: "Beklenmeyen hata oluştu",
            offlineError: "Kaynak almaya çalışılırken Ağ Hatası oluştu.",
            parseJSONError: "Hata JSON gövdesi ayrıştırılamıyor."
        }
    }
};
exports.bundled["zh-Hans"] = {
    Connector: {
        Errors: {
            defaultError: "发生意外错误。",
            offlineError: "尝试提取资源时出现网络错误。",
            parseJSONError: "无法对错误 JSON 正文进行语法分析。"
        }
    }
};
exports.bundled["zh-Hant"] = {
    Connector: {
        Errors: {
            defaultError: "發生未預期的錯誤.",
            offlineError: "嘗試擷取資源時發生 NetworkError.",
            parseJSONError: "無法剖析錯誤的 JSON 主體."
        }
    }
};
exports.i18n = new loom_i18n_1.LoomI18n();
/**
 * Initialize the instance. If no {@code defaultLanguage} are provided, tries to automatically detect the language
 * @param defaultLanguage The language to use initially
 */
function init(defaultLanguage, localeOptions) {
    exports.i18n.initSync({
        defaultLanguage: defaultLanguage,
        resources: exports.bundled,
        localesData: {
            en: en_1.default,
            ar: ar_1.default,
            cs: cs_1.default,
            da: da_1.default,
            de: de_1.default,
            el: el_1.default,
            es: es_1.default,
            fi: fi_1.default,
            fr: fr_1.default,
            hr: hr_1.default,
            hu: hu_1.default,
            it: it_1.default,
            ja: ja_1.default,
            ko: ko_1.default,
            nl: nl_1.default,
            no: no_1.default,
            pl: pl_1.default,
            pt: pt_1.default,
            ro: ro_1.default,
            ru: ru_1.default,
            sk: sk_1.default,
            sl: sl_1.default,
            sr: sr_1.default,
            sv: sv_1.default,
            th: th_1.default,
            tr: tr_1.default,
            zh: zh_1.default
        },
        defaultCurrency: localeOptions && localeOptions.defaultCurrency,
        defaultTimezone: localeOptions && localeOptions.defaultTimezone
    });
}
exports.init = init;
/**
 * Add a notification callback on initialization time. Please set this before you call @method init
 * @param callback
 */
function onInit(callback) {
    exports.i18n.onInit(callback);
}
exports.onInit = onInit;
/**
 * Helper functions for i18n.
 */
exports.i18nUtils = {
    /**
     * Function to format currency.
     * @param value
     * @deprecated We will be removing "Code" and only have optional "Options" object where you can specify the currency
     * @param codeOrOptions Currency code to use, defaults to USD. Use getCurrencyCode to map string to Currency.Code enum
     * or Options object to set currencyCode(defaults to USD), displayFormat(Defaults to Symbol) and precision
     * @deprecated We will be removing "displayFormat" in the future. You can set this in the Options object
     * @param displayFormat Display as symbol or name. Eg. $5.00 or 5 US Dollars, Defaults to Symbol.
     * This is ignored if "Options" object is provided
     */
    formatCurrency: function formatCurrency(value, codeOrOptions, displayFormat) {
        return exports.i18n.formatCurrency(value, codeOrOptions, displayFormat);
    },
    /**
     * Get Currency.Code enum from the specified string. If not found, returns the string value cast as enum.
     * @param code Currency code string to look up.
     */
    getCurrencyCode: function getCurrencyCode(code) {
        return loom_i18n_1.Currency.Code.code || code;
    }
};
/**
 * Add a notification callback on missing translation key. Useful for applications that may need to do
 * work once the translation key is missing in translation files.
 * @param callback
 */
function onMissingKey(callback) {
    exports.i18n.onMissingKey(callback);
}
exports.onMissingKey = onMissingKey;
/**
 * Function to check if the instance is initialized.
 */
function isInit() {
    return exports.i18n.isInitialized;
}
exports.isInit = isInit;
/**
 * Change the language of the current instance.
 * @param language New language to use. Can be either language code (e.g. "en"), or locale code (e.g. "en-US"))
 */
function changeLanguage(language) {
    return exports.i18n.changeLanguage(language);
}
exports.changeLanguage = changeLanguage;
/**
 * Add a notification callback on change of language. Useful for applications that may need
 * to do work once the language is changed (e.g. forceUpdate of the root component in react)
 * @param callback
 */
function onLanguageChanged(callback) {
    exports.i18n.onLanguageChanged(callback);
}
exports.onLanguageChanged = onLanguageChanged;
exports.Connector = {
    Errors: {
        defaultError: function Connector_Errors_defaultError() {
            return exports.i18n.t("Connector.Errors.defaultError", {});
        },
        offlineError: function Connector_Errors_offlineError() {
            return exports.i18n.t("Connector.Errors.offlineError", {});
        },
        parseJSONError: function Connector_Errors_parseJSONError() {
            return exports.i18n.t("Connector.Errors.parseJSONError", {});
        }
    }
};
//# sourceMappingURL=Messages.js.map